import React, { useRef } from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { GridRow, GridItem } from '@tvg/fuse/grid';
import AlertsComponent from 'components/Alert/AlertsComponent';
import allItemsOutOfStock from 'utilities/sku/isAllOptionsOutOfStock';
import { StockCode } from 'types/ProductResponseType';
import { useExperimentsContext } from 'context/ExperimentsContext';
import { ProductPriceAmount } from 'types/Product';
import AddToBasketButton from './AddToBasketButton';
import StickyAddToBasketButton from './StickyAddToBasketButton';
import styles from './AddToBasket.module.css';

interface Props {
  productData: {
    price: ProductPriceAmount;
    reviewTotal?: number;
    reviewStars?: number;
  };
}

function AddToBasket({ productData }: Props) {
  const {
    errorMessage,
    handleDigitalDownloadDialogueRender,
    handleAddToBasket,
    hasError,
    digitalDownload,
    skus,
    selectedSku,
    amendBasketEnabled,
    isAddingToBasket,
  } = useSelectedSkuContext();

  const primaryAddToBasketButtonRef = useRef<HTMLDivElement>(null);
  const experiments = useExperimentsContext();
  const challengerEnabled = experiments['se-8'];

  const isDisabled =
    isAddingToBasket ||
    allItemsOutOfStock(skus) ||
    selectedSku?.stock?.code === StockCode.OUTOFSTOCK ||
    selectedSku?.stock?.code === StockCode.UNAVAILABLE;

  const atbHandler = digitalDownload ? handleDigitalDownloadDialogueRender : handleAddToBasket;

  return (
    <div data-cnstrc-btn="add_to_cart" data-testid="add-to-basket">
      {challengerEnabled ? (
        <>
          <div className={styles.desktopOnly}>
            {hasError && (
              <GridRow>
                <GridItem xxs={12}>
                  <AlertsComponent errorMessage={errorMessage} />
                </GridItem>
              </GridRow>
            )}
            <AddToBasketButton
              ref={primaryAddToBasketButtonRef}
              handleAddToBasket={atbHandler}
              disabled={isDisabled}
              updateBasket={amendBasketEnabled}
            />
          </div>

          <div className={styles.mobileOnly}>
            <StickyAddToBasketButton
              primaryAddToBasketButtonRef={primaryAddToBasketButtonRef}
              handleAddToBasket={atbHandler}
              disabled={isDisabled}
              updateBasket={amendBasketEnabled}
              errorMessage={hasError ? errorMessage : undefined}
              productData={productData}
            />
          </div>
        </>
      ) : (
        <>
          {hasError && (
            <GridRow>
              <GridItem xxs={12}>
                <AlertsComponent errorMessage={errorMessage} />
              </GridItem>
            </GridRow>
          )}
          <AddToBasketButton
            ref={primaryAddToBasketButtonRef}
            handleAddToBasket={atbHandler}
            disabled={isDisabled}
            updateBasket={amendBasketEnabled}
          />
          <StickyAddToBasketButton
            primaryAddToBasketButtonRef={primaryAddToBasketButtonRef}
            handleAddToBasket={atbHandler}
            disabled={isDisabled}
            updateBasket={amendBasketEnabled}
            errorMessage={hasError ? errorMessage : undefined}
            productData={productData}
          />
        </>
      )}
    </div>
  );
}

export default AddToBasket;
